import { CalendarCheck } from "lucide-react"

/**
 * #197 (Marlene, 19.10.2026): Hat die Mail inzwischen einen Termin, steht das
 * ganz oben im Detail — nicht die alten Terminvorschläge.
 *
 * Gezeigt werden nur Datum, Uhrzeit und Titel des Termins (kommt fertig
 * formuliert vom Server), keine Kundendaten und keine HERO-IDs.
 */
export type TerminBestaetigt = {
  /** `gebucht` (Portal), `hero` (Nachschau fand ihn in HERO), `kunde_bestaetigt` */
  quelle: string
  start?: string | null
  ende?: string | null
  titel?: string | null
  text: string
  /** true = Terminvorschläge der Mail sind überholt */
  ueberholt: boolean
}

export function terminBannerUeberschrift(t: Pick<TerminBestaetigt, "quelle">): string {
  return t.quelle === "kunde_bestaetigt" ? "Kunde hat den Termin bestätigt" : "Termin gebucht"
}

export function TerminBestaetigtBanner({ termin }: { termin?: TerminBestaetigt | null }) {
  if (!termin || !termin.text) return null
  const nochOffen = termin.quelle === "kunde_bestaetigt"
  return (
    <div
      role="status"
      data-testid="termin-bestaetigt-banner"
      style={{
        display: "flex", gap: 10, alignItems: "flex-start",
        margin: "12px 20px 0", padding: "10px 14px", borderRadius: 8,
        border: "1px solid #059669", background: "rgba(5, 150, 105, 0.10)",
        color: "var(--text-primary)",
      }}
    >
      <CalendarCheck className="w-5 h-5" style={{ color: "#059669", flexShrink: 0, marginTop: 1 }} />
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 14, fontWeight: 600 }}>
          {terminBannerUeberschrift(termin)}: {termin.text}
          {termin.titel && <span style={{ fontWeight: 400, color: "var(--text-muted)" }}> · {termin.titel}</span>}
        </div>
        <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 2 }}>
          {nochOffen
            ? "Der Termin ist noch nicht im Kalender — bitte buchen."
            : "Die Terminvorschläge dieser Mail sind damit überholt."}
        </div>
      </div>
    </div>
  )
}
